import { render, staticRenderFns } from "./infoAditional.vue?vue&type=template&id=3fbd6e24&"
import script from "./infoAditional.vue?vue&type=script&lang=js&"
export * from "./infoAditional.vue?vue&type=script&lang=js&"
import style0 from "./infoAditional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports